export const UNTENANTED_PRODUCTS: string[] = ['TRELLO', 'BITBUCKET'];
